import { useCallback, useContext } from 'react';
import { cloneDeep } from 'lodash';
import { AppContext } from 'providers/AppProvider';
import { baseAction, changeLanguageAction } from 'store/actions';
import { buildAppState, Language, LANGUAGE_PAYLOADS } from 'store/state';
import { EntityProcessInfo } from 'types';
import { isLogged } from 'helpers';

export const DEFAULT_RELATIONS = {
	children: [] as EntityProcessInfo[],
	companies: [] as EntityProcessInfo[],
	person: {} as EntityProcessInfo
};

export function useTopBar() {
	const ctx = useContext(AppContext);
	const { config, dispatch, fetchRelations, Relations, http, state } = ctx;
	const { language } = state.language;

	const logout = useCallback(() => {
		const payload = { ...buildAppState(), language: cloneDeep(state.language) };
		dispatch([baseAction, payload]);
	}, [state.language, dispatch]);

	const changeLanguage = useCallback(() => {
		const languages = Object.keys(LANGUAGE_PAYLOADS) as Language[];
		const nextLang = languages.indexOf(language) + 1;
		const key = languages[nextLang] || languages[0];
		dispatch([
			changeLanguageAction,
			{
				language: {
					...state.language,
					...LANGUAGE_PAYLOADS[key]
				}
			}
		]);
	}, [language, state.language, dispatch]);

	const resetProcesses = useCallback(() => {
		const { API } = config;
		const { children, companies, person } = Relations();
		const items = [...children, ...companies, person].filter(x => (x.processInfo ? x : false));
		Promise.all(
			items.map(({ processInfo }) => {
				return http.delete(`${API.deleteProcess}/${processInfo.agreementProcessId}`);
			})
		).then(() => fetchRelations());
	}, [config, http, fetchRelations, Relations]);

	return {
		...ctx,
		isLogged: isLogged(state.user),
		logout,
		changeLanguage,
		resetProcesses
	};
}
